import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../blocks/heigh-educate-banner";
import { HeighEducateChallenge } from "../../blocks/customer-heigh-educate-challenge";
import { HeighEducateIdea } from "../../blocks/customer-heigh-educate-idea";
import { CustomerConsult } from "../../blocks/common-customer-consult";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../blocks/customer-detail-intro";
import { Footer } from "../../components/Footer";
import { CustomerDetailChallenge } from "../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../blocks/home-try-on";

export const CNPNPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.cnpn.challenge.item1.title"),
      description: t("customer.cnpn.challenge.item1.description"),
    },
    {
      title: t("customer.cnpn.challenge.item2.title"),
      description: t("customer.cnpn.challenge.item2.description"),
    },
    {
      title: t("customer.cnpn.challenge.item3.title"),
      description: t("customer.cnpn.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.cnpn.ideas.item1.title"),
      descript: t("customer.cnpn.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.cnpn.ideas.item2.title"),
      descript: t("customer.cnpn.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.cnpn.ideas.item3.title"),
      descript: t("customer.cnpn.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="cnpn-page">
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.cnpn.banner.title")}
        subtitle={t("customer.cnpn.banner.subtitle")}
        theme="#E68B3C"
        imgUrl={
          "//files.authing.co/authing-website/customer-story-detail-banner-cnpn-tiny.png"
        }
      />
      <CustomerDetailIntro
        imgUrl={t("customer.cnpn.intro.imgUrl")}
        content={
          <>
            <p>{t("customer.cnpn.intro.descript1")}</p>
            <p>{t("customer.cnpn.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#E68B3C"} />
      <CustomerDetailIdea ideas={ideas} theme={"#E68B3C"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#E68B3C"} />
      {/* <CustomerConsult /> */}
      <div style={{ paddingTop: 120 }}>
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
